import React from 'react';
import { Paper, Typography, Box, Button } from '@mui/material';
import {
  formContainerSx,
  sectionTitleSx,
  tripCreatedBoxSx,
  tripCodeSx,
  tripCreatedGridSx,
  tripCreatedActionsSx
} from '../layout/styles/NewTripForm.styles';
import { TripCreationResponse } from '../../types/newTripForm';

interface TripCreatedSummaryProps {
  createdTripCode: string;
  tripCreationResponse: TripCreationResponse;
  onStartOver: () => void;
  onClose: () => void;
}

const TripCreatedSummary: React.FC<TripCreatedSummaryProps> = ({
  createdTripCode,
  tripCreationResponse,
  onStartOver,
  onClose
}) => (
  <Paper sx={formContainerSx}>
    <Typography variant="h6" sx={sectionTitleSx}>Trip Created Successfully</Typography>
    <Box sx={tripCreatedBoxSx}>
      <Typography variant="h6" sx={tripCodeSx}>
        Trip Code: {createdTripCode}
      </Typography>
      {/* <Box sx={tripCreatedGridSx}>
        <Box>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Trip Status
          </Typography>
          <Typography variant="body1" fontWeight="medium" sx={{ color: '#ff9800' }}>
            {tripCreationResponse.data.tripStatus}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Customer
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {tripCreationResponse.data.customer?.name || 'Customer'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Route
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {tripCreationResponse.data.sourceCity} → {tripCreationResponse.data.destinationCities}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Start Date
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {new Date(tripCreationResponse.data.startDatetime).toLocaleString('en-IN')}
          </Typography>
        </Box>
      </Box> */}
      <Box sx={tripCreatedActionsSx}>
        <Button
          variant="contained"
          color="primary"
          onClick={onStartOver}
          size="large"
        >
          Create Another Trip
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
          size="large"
        >
          Close
        </Button>
      </Box>
    </Box>
  </Paper>
);

export default TripCreatedSummary;